import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import ReactSelect from 'react-select';
import {
  SlideContent,
  ModalDescription,
  SelectWrapper,
  Label,
  SelectContainer,
  ButtonsContainer,
  PrimaryButton,
  SecondaryButton,
} from '../shared';

const SingleSelectGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;
`;

const BulkCopySlide3 = ({
  pasteWeek,
  pasteWeekOptions,
  onPasteWeekChange,
  selectedCalendarCount,
  onBack,
  onNext,
}) => {
  const calendarWord = selectedCalendarCount === 1 ? 'calendar' : 'calendars';

  return (
    <SlideContent>
      <ModalDescription>
        {`Select the start week into which you would like to paste the copied planner blocks for the selected ${calendarWord}. Pasted content will appear in the next available row in the range.`}
      </ModalDescription>

      <SingleSelectGroup>
        <SelectWrapper>
          <Label htmlFor='paste-start-week'>Target Start Date</Label>
          <SelectContainer>
            <ReactSelect
              inputId='paste-start-week'
              value={pasteWeek}
              onChange={onPasteWeekChange}
              options={pasteWeekOptions}
              classNamePrefix='react-select'
              isSearchable={false}
              placeholder='Select week'
              menuPlacement='auto'
            />
          </SelectContainer>
        </SelectWrapper>
      </SingleSelectGroup>

      <ButtonsContainer>
        <PrimaryButton onClick={onNext} disabled={!pasteWeek}>
          Next
        </PrimaryButton>
        <SecondaryButton onClick={onBack}>
          Back
        </SecondaryButton>
      </ButtonsContainer>
    </SlideContent>
  );
};

BulkCopySlide3.propTypes = {
  pasteWeek: PropTypes.shape({ value: PropTypes.string, label: PropTypes.string }),
  pasteWeekOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  })).isRequired,
  onPasteWeekChange: PropTypes.func.isRequired,
  selectedCalendarCount: PropTypes.number.isRequired,
  onBack: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
};

BulkCopySlide3.defaultProps = {
  pasteWeek: null,
};

export default BulkCopySlide3;
